import { Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  removeUpdatingVisaAdded,
  updateVisaSelected,
} from "../../actions/proposal";
import * as Yup from "yup";
import { closeModal } from "../../actions/ui";
import { numberNotation } from "../../helper/numberStructure";
import Input from "../Forms/Inputs/Input";

import "./VisaCardForEditing.scss";

const VisaCardForEditing = () => {
  const { visaToUpdate } = useSelector((state) => state.proposals);
  const dispatch = useDispatch();

  const initialValues = {
    quantity: visaToUpdate.quantity,
    visafee: visaToUpdate.visafee,
    extrafee: visaToUpdate.extrafee,
  };
  const visaSchema = Yup.object().shape({
    quantity: Yup.number().required("Number Required").min(1, "Invalid number"),
    visafee: Yup.number().required("Number Required"),
    extrafee: Yup.number().required("Number Required").min(0, "Invalid number"),
  });

  const handleFormikSubmit = (values) => {
    const { visafee, extrafee, quantity } = values;
    const total = visafee * quantity + extrafee;

    const visaUpdated = { ...visaToUpdate, visafee, extrafee, quantity, total };
    dispatch(updateVisaSelected(visaUpdated));
    dispatch(removeUpdatingVisaAdded());
    dispatch(closeModal());
  };

  return (
    <div className="visa-form-for-editing">
      <div className="visa-form-for-editing__wrapper">
        <div className="visa-form-for-editing__heading">
          <h2 className="title-gray-black-18">{visaToUpdate.name}</h2>
          <h2 className="paragraph-gray-reg-16">{visaToUpdate.subname}</h2>
        </div>
        <Formik
          validationSchema={visaSchema}
          initialValues={initialValues}
          onSubmit={handleFormikSubmit}
          enableReinitialize
        >
          {({ values }) => {
            const { visafee, extrafee, quantity } = values;
            const total = visafee * quantity + extrafee;

            return (
              <Form>
                <Input
                  name="quantity"
                  label={`Quantity`}
                  type="number"
                  isModal={true}
                />
                <Input
                  name="visafee"
                  label={`Visa Fee`}
                  type="number"
                  isModal={true}
                />
                <Input
                  name="extrafee"
                  label={`Extra Fee`}
                  type="number"
                  isModal={true}
                />

                <div className="total-visa__updated">
                  <h2 className="paragraph-gray-reg-16">Total</h2>
                  <h2 className="title-gray-black-18">
                    $A{" "}
                    {
                      numberNotation(total)
                      // total.toLocaleString("en-US")
                    }
                  </h2>
                </div>
                <button type="submit" className="btn-primary">
                  Update
                </button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default VisaCardForEditing;
